import React from 'react';

interface SpacerProps {
  count?: 1 | 2 | 3 | 4;
}

/**
 * This component is useful when you are using grid and want expand whitespace
 * uniformly per a grid's `grid-gap`. Additionally it has better readability
 * than a random `<div />`. This also avoids the smattering of margin/padding on
 * `Box` components or divs to get proper visual spacing.
 */
const Spacer = ({ count = 1 }: SpacerProps) => (
  <>
    {Array.from(Array(count), (_, x) => x).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div data-spacer key={index} />
    ))}
  </>
);

export { Spacer };
